export const loadState = () => {
  try {
    const serialisedState = sessionStorage.getItem('state')
    if (serialisedState) {
      return JSON.parse(serialisedState)
    }
  } catch (e) {
  }

  return undefined
}

export const saveState = state => {
  try {
    sessionStorage.setItem('state', JSON.stringify(state))
  } catch (e) {

  }
}
